import { render, staticRenderFns } from "./ResultCard.vue?vue&type=template&id=5b3ddcd6"
import script from "./ResultCard.vue?vue&type=script&lang=js"
export * from "./ResultCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports